/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import Photochromatic from './Photochromatic'

export default class Tier {
  readonly uid: string
  readonly name: string
  readonly heading: string
  readonly description: string
  readonly hasPhotochromatic: boolean
  readonly photochromatic?: Photochromatic
  public readonly retailPrice: number
  public readonly procedureCode: string

  constructor (json: any) {
    this.uid = json._metadata.uid
    this.name = json.procedure_code[0].title
    this.heading = json.heading
    this.description = json.description
    this.hasPhotochromatic = json.subop_slider && json.subop_slider.subop_slider_images.length > 0
    if (this.hasPhotochromatic) {
      this.photochromatic = Photochromatic.of(json.subop_slider, true)
    }

    const jsonProcedureCode = json.procedure_code[0]
    this.retailPrice = Number.parseFloat(jsonProcedureCode.retail_price)
    this.procedureCode = jsonProcedureCode.procedure_code
  }

  public static of (json: any) {
    return new Tier(json)
  }
}
